module.exports = __webpack_public_path__ + "static/media/terralanes-logo-logistics-visualization-software-nashville-tn@2x.2a15d0cf.svg";